const getDeepestTreeLevelForSku = (variantTreeLevel, sku) => {
  for (const variantFacetItem of variantTreeLevel) {
    const childFacetItem = getDeepestTreeLevelForSku(variantFacetItem.childFacets, sku);
    if (childFacetItem) return variantFacetItem.childFacets;
    if (variantFacetItem.skuCollection.includes(sku) && variantFacetItem.facetTerm) {
      return [variantFacetItem];
    }
  }
  return void 0;
};
export {
  getDeepestTreeLevelForSku
};
//# sourceMappingURL=get-deepest-tree-level-for-sku.js.map
